import React from 'react';
import { Dropdown } from '@geberit/gdds';

// types
import type { SelectOption } from '@geberit/gdds/dist/esm/form/Dropdown/types/Dropdown.types';

// utils
import { useTracking } from 'utils/hooks/useTracking';
import { decodingContent } from 'utils/decodingContent';
import { isEmpty } from 'utils/is-empty';
import { locatorEvent } from '../tracking-actions';

type CategoryFilterProps = {
  filterCategories: string[] | null;
  setFilterCategory: (category: string | null) => void;
  label: string;
  sortedF1Categories: string[] | null;
  isMobile: boolean;
  filterCategory?: string | null;
};

function CategoryFilter({
  filterCategories = null,
  filterCategory = null,
  setFilterCategory,
  label,
  sortedF1Categories,
  isMobile,
}: Readonly<CategoryFilterProps>) {
  const track = useTracking();

  if (isEmpty(filterCategories)) return null;

  const handleFilterClick = (option: string) => {
    setFilterCategory(filterCategory === option ? null : option || null);
    track.trackEvent(locatorEvent('Locator-Search', option || label));
  };

  let categories: string[];
  if (!isEmpty(sortedF1Categories)) {
    categories = sortedF1Categories.filter((item) => filterCategories?.includes(item));
  } else {
    categories = filterCategories;
  }

  return (
    <Dropdown
      placeholder={decodingContent(filterCategory ?? label)}
      name="category"
      outlined
      defaultValue={filterCategory ?? ''}
      flyoutMaxItemsCount={isMobile ? 5 : 9}
      items={categories
        .filter((x) => x)
        .map((value) => ({
          id: value,
          value: value,
          text: decodingContent(value),
        }))}
      onChange={(option) => {
        handleFilterClick((option as SelectOption)?.value);
      }}
      forceCustom
    />
  );
}

export default CategoryFilter;
